// extracted by mini-css-extract-plugin
export var cardIcon = "_67-5";
export var cardIconUnframed = "_67-9";
export var checkboxCard = "_67-0";
export var checkboxCardSelected = "_67-4";
export var disabled = "_67-2";
export var interactive = "_67-1";
export var outerBorder = "_67-3";
export var spacerMedium = "_67-8";
export var spacerSmall = "_67-7";
export var spacerXsmall = "_67-6";